module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "Dashboardpdf",
    attrs: {
      "id": "Dashboardpdf"
    }
  }, [_c('section', {
    staticClass: "dashboard"
  }, [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showDash == true) ? _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousPage
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n      ")], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('h4', {
    staticClass: "page-title mb-1"
  }, [_vm._v("TPT GR Dashboard")])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('date-range-picker', {
    staticClass: "mb-1",
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": _vm.getDataTPTGRDashboard
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": _vm.getDataTPTGRDashboard
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeName,
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "Select Export / Import"
    },
    on: {
      "input": _vm.getDataTPTGRDashboard
    },
    model: {
      value: (_vm.transportTypeFilter),
      callback: function($$v) {
        _vm.transportTypeFilter = $$v
      },
      expression: "transportTypeFilter"
    }
  })], 1), _vm._v(" "), (_vm.GRNDetails.length > 0) ? _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export as Excel' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReportsAss('Excel', 'TPTGRDashbord')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export as Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.GRNDetails.length > 0) ? _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "2"
    }
  }, [(_vm.GRNDetails.length > 0) ? _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.exportGRNReportDashboard()
      }
    }
  }, [_vm._v("Export Vehicle GRN")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "gutr mt-3"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.ActiveGenrateGRGraph[0].data.length > 0) ? _c('div', {
    staticClass: "col-xl-12 col-md-12 grid-margin stretch-card mt-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {}, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("Total GR Genrate")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [(_vm.ActiveGenrateGRGraph[0].data.length > 0) ? _c('apexchart', {
    staticClass: "mt-3",
    attrs: {
      "type": "bar",
      "height": "800",
      "width": "100%",
      "options": _vm.chartOptionsGenrateGRGraph,
      "series": _vm.ActiveGenrateGRGraph
    }
  }) : _vm._e()], 1)])])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row gutr"
  }), _vm._v(" "), _c('b-row', [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "reg": "GRNDetailsRef",
      "items": _vm.GRNDetails,
      "fields": _vm.fields,
      "responsive": "",
      "primary-key": "EDate",
      "show-empty": "",
      "stacked": "md",
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "EDate",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "aria-controlles": "GRNDetails",
      "limit": "30",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows,
      "first-number": "",
      "last-number": ""
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1) : _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "info"
    }
  }, [(_vm.showDash == false) ? _c('b-navbar-brand', [(_vm.employeeName != '') ? _c('h4', {
    staticClass: "page-title"
  }, [_vm._v("\n            Welcome "), _c('small', [_vm._v(_vm._s(_vm.employeeName))])]) : _vm._e()]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop22",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b145e66","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/tptGRDashboard.vue
// module id = 2535
// module chunks = 0